import { render } from "./NcrmContacts.vue?vue&type=template&id=593a0ca6&scoped=true"
import script from "./NcrmContacts.vue?vue&type=script&lang=js"
export * from "./NcrmContacts.vue?vue&type=script&lang=js"

import "./NcrmContacts.styles.css?vue&type=style&index=0&id=593a0ca6&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593a0ca6"]])

export default __exports__